
// Test two sets of strings for equality
function eqStringSet(as: Set<string>, bs: Set<string>) {
    if (as.size !== bs.size) return false;
    for (const a of as) if (!bs.has(a)) return false;
    return true;
}

export { eqStringSet }